import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';
import { Text } from 'react-aria-components';

const styles = css(Object.assign(Object.assign({}, Typography.SmallPrint1), { color: `var(--zds-text-weaker, ${Colors.GrayWarm9})`, '&[data-compact="true"]': Object.assign({}, Typography.MinimalPrint1) }));
const Description = (_a) => {
  var { children, isCompact } = _a, props = __rest(_a, ["children", "isCompact"]);
  return jsx(Text, Object.assign({ slot: "description" }, props, { css: styles, "data-compact": isCompact, "data-zds": true }), children);
};

export { Description };
//# sourceMappingURL=Description.es.js.map
